/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bakery_Rule_Table_Reward_Cupcake_TitleInputs */

const en_bakery_rule_table_reward_cupcake_title = /** @type {(inputs: Bakery_Rule_Table_Reward_Cupcake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12th Anniversary Cupcakes`)
};

const ar_bakery_rule_table_reward_cupcake_title = /** @type {(inputs: Bakery_Rule_Table_Reward_Cupcake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كب كيك الذكرى السنوية الـ12`)
};

const de_bakery_rule_table_reward_cupcake_title = /** @type {(inputs: Bakery_Rule_Table_Reward_Cupcake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcakes zum 12. Jubiläum`)
};

const es_bakery_rule_table_reward_cupcake_title = /** @type {(inputs: Bakery_Rule_Table_Reward_Cupcake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcakes del 12.º aniversario`)
};

const fr_bakery_rule_table_reward_cupcake_title = /** @type {(inputs: Bakery_Rule_Table_Reward_Cupcake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcakes du 12e anniversaire`)
};

const it_bakery_rule_table_reward_cupcake_title = /** @type {(inputs: Bakery_Rule_Table_Reward_Cupcake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcake del 12° anniversario`)
};

const ja_bakery_rule_table_reward_cupcake_title = /** @type {(inputs: Bakery_Rule_Table_Reward_Cupcake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12周年記念カップケーキ`)
};

const ko_bakery_rule_table_reward_cupcake_title = /** @type {(inputs: Bakery_Rule_Table_Reward_Cupcake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12주년 컵케이크`)
};

const pt_br_bakery_rule_table_reward_cupcake_title = /** @type {(inputs: Bakery_Rule_Table_Reward_Cupcake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcakes do 12º aniversário`)
};

const ru_bakery_rule_table_reward_cupcake_title = /** @type {(inputs: Bakery_Rule_Table_Reward_Cupcake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Капкейки в честь 12-летия`)
};

const th_bakery_rule_table_reward_cupcake_title = /** @type {(inputs: Bakery_Rule_Table_Reward_Cupcake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คัพเค้กครบรอบ 12 ปี`)
};

const tr_bakery_rule_table_reward_cupcake_title = /** @type {(inputs: Bakery_Rule_Table_Reward_Cupcake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Yıl Dönümü Cupcake'leri`)
};

const zh_cn_bakery_rule_table_reward_cupcake_title = /** @type {(inputs: Bakery_Rule_Table_Reward_Cupcake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 周年纸杯蛋糕`)
};

const zh_tw_bakery_rule_table_reward_cupcake_title = /** @type {(inputs: Bakery_Rule_Table_Reward_Cupcake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 週年杯子蛋糕`)
};

/**
* | output |
* | --- |
* | "12th Anniversary Cupcakes" |
*
* @param {Bakery_Rule_Table_Reward_Cupcake_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const bakery_rule_table_reward_cupcake_title = /** @type {((inputs?: Bakery_Rule_Table_Reward_Cupcake_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bakery_Rule_Table_Reward_Cupcake_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bakery_rule_table_reward_cupcake_title(inputs)
	if (locale === "ar") return ar_bakery_rule_table_reward_cupcake_title(inputs)
	if (locale === "de") return de_bakery_rule_table_reward_cupcake_title(inputs)
	if (locale === "es") return es_bakery_rule_table_reward_cupcake_title(inputs)
	if (locale === "fr") return fr_bakery_rule_table_reward_cupcake_title(inputs)
	if (locale === "it") return it_bakery_rule_table_reward_cupcake_title(inputs)
	if (locale === "ja") return ja_bakery_rule_table_reward_cupcake_title(inputs)
	if (locale === "ko") return ko_bakery_rule_table_reward_cupcake_title(inputs)
	if (locale === "pt_br") return pt_br_bakery_rule_table_reward_cupcake_title(inputs)
	if (locale === "ru") return ru_bakery_rule_table_reward_cupcake_title(inputs)
	if (locale === "th") return th_bakery_rule_table_reward_cupcake_title(inputs)
	if (locale === "tr") return tr_bakery_rule_table_reward_cupcake_title(inputs)
	if (locale === "zh_cn") return zh_cn_bakery_rule_table_reward_cupcake_title(inputs)
	return zh_tw_bakery_rule_table_reward_cupcake_title(inputs)
});